var map = {
	"./task1.jpg": 5800,
	"./task10.jpg": 2066,
	"./task11.jpg": 8447,
	"./task12.jpg": 1808,
	"./task13.jpg": 1021,
	"./task14.jpg": 502,
	"./task15.jpg": 5763,
	"./task16.jpg": 2068,
	"./task17.jpg": 113,
	"./task18.jpg": 2762,
	"./task2.jpg": 4199,
	"./task3.jpg": 362,
	"./task4.jpg": 1049,
	"./task5.jpg": 3004,
	"./task6.jpg": 5803,
	"./task7.jpg": 7966,
	"./task8.jpg": 2237,
	"./task9.jpg": 1104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2192;